// extracted by mini-css-extract-plugin
export default {"tip":"ProfileButton_tip__GK74s"};